finderApp.filter('priceTag', function () {

    // skip parsing price tag in case there is no price configuration available
    if (typeof(finderConfig.currencyCode) == 'undefined'
        || finderConfig.currencyConfig == 'undefined'
        || finderConfig.currencyConfig[currency] == 'undefined') {
        return function (text) {
            return text;
        }
    }

    var currency = finderConfig.currencyCode;
    var config = finderConfig.currencyConfig[currency];
    var tag = new RegExp("<price ([^\/])+\/>");

    // from: http://phpjs.org/functions/number_format/
    function number_format(number, decimals, dec_point, thousands_sep) {
        number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
        var n = !isFinite(+number) ? 0 : +number,
            prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
            sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
            dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
            s = '',
            toFixedFix = function (n, prec) {
                var k = Math.pow(10, prec);
                return '' + (Math.round(n * k) / k).toFixed(prec);
            };
        // Fix for IE parseFloat(0.55).toFixed(0) = 0;
        s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
        if (s[0].length > 3) {
            s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
        }
        if ((s[1] || '').length < prec) {
            s[1] = s[1] || '';
            s[1] += new Array(prec - s[1].length + 1).join('0');
        }
        return s.join(dec);
    }

    return function (text) {
        if (typeof text != "string") {
            return text;
        }
        return String(text).replace(tag,
            function (x) {
                // extract proper currency
                var curRegExp = new RegExp(currency + '="?([\\d\\.,]+)"?', 'gi');
                var r = '';
                if (r = curRegExp.exec(x)) {
                    // add currency format
                    return config.position.replace('|', number_format(r[1], config.decimals, config.separator, config.thousand));
                }
                return '';
            }
        );
    };
});